import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid';
import { FirmActiveWork } from '../../../types/firm';
import { TooltipV2 } from '@cimplico/components';
import PieChart from './PieChart';
import plural from '../../../utilities/plural';

type PieChartInsightsProps = {
    activeWork: FirmActiveWork;
};

function PieChartInsights({ activeWork }: PieChartInsightsProps): JSX.Element {
    const { activeCount, overdueCount } = activeWork;

    const onScheduleCount = activeCount - overdueCount;
    const onSchedulePercent = (onScheduleCount / activeCount) * 100;
    const overduePercent = (overdueCount / activeCount) * 100;

    const slices = [
        {
            legend: 'On-schedule',
            color: '#34D399',
            count: onScheduleCount,
            percent: onSchedulePercent,
            title: `On-schedule ${onSchedulePercent.toFixed(2)}% (${onScheduleCount} ${plural(
                onScheduleCount,
                'workpaper',
                'workpapers'
            )})`,
        },
        {
            legend: 'Overdue',
            color: '#FB923C',
            count: overdueCount,
            percent: overduePercent,
            title: `Overdue ${overduePercent.toFixed(2)}% (${overdueCount} ${plural(overdueCount, 'workpaper', 'workpapers')})`,
        },
    ];

    return (
        <div className="border rounded-lg border-gray-200 bg-white dark:bg-white/[0.05] dark:border-white/[0.07] p-6 flex flex-col gap-y-4">
            <div className="flex justify-between items-center border-b border-gray-200 dark:border-white/[0.07] pb-2">
                <h1 className="text-sm font-bold text-gray-800 dark:text-gray-300">On-schedule vs Overdue</h1>
                <div>
                    <TooltipV2
                        message="See the ratio of current workpapers that are on-schedule against current workpapers that are overdue."
                        position="right"
                    >
                        <QuestionMarkCircleIcon className="w-5 h-5 text-gray-500" />
                    </TooltipV2>
                </div>
            </div>
            <PieChart slices={slices} />
        </div>
    );
}

export default PieChartInsights;
